import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

import resource from '../../config/resource.json';
import { DomSanitizer } from '@angular/platform-browser';
import { ServiceManagerService } from '../service-manager.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  
  resource: any = resource
  appProperties: any = {
    "home": {
      "backgroundColor": "#FFF2E7",
      "backgroundLogo": this.resource.image.home_bg_logo
    },
    "landing-page": {
      "backgroundColor": "#FFF2E7",
      "backgroundLogo": this.resource.image.home_bg_logo
    },
    "menu": {
      "backgroundColor": "#F8F8F8",
      "backgroundLogo": ""
    },
    "about": {
      "backgroundColor": "#F8F8F8",
      "backgroundLogo": ""
    },
    "change-language": {
      "backgroundColor": "#F8F8F8",
      "backgroundLogo": ""
    },
    "policy-terms": {
      "backgroundColor": "#F8F8F8",
      "backgroundLogo": ""
    },
    "resource": {
      "backgroundColor": "#F8ECFF",
      "backgroundLogo": this.resource.image.resource_bg_logo
    },
    "self-care": {
      "backgroundColor": "#FFF2FC",
      "backgroundLogo": this.resource.image.self_care_bg_logo
    },
    "safety-plan": {
      "backgroundColor": "#EBFAEE",
      "backgroundLogo": this.resource.image.safety_plan_bg_logo
    }
  }
  availableClient: any = []
  chatExist: boolean = false;
  chatTransferred: boolean = false;
  currentDevice: any;
  current: any = {
    page: "HOME",
    status: "INITIAL"
  }
  unreadMessage = 0;
  userId: any;
  peerDetails: any;
  peerStatus: any = "IDEAL";
  selectedPeer: any = {};
  socketCheckTime: any;

  /**
   * Subject to access the entire page
   */
  appModalEvent = new Subject()
  chatEnded = new Subject()
  chatScroll = new Subject()
  messageReceived = new Subject();
  showChat = new Subject()
  isChatShowed = false;

  /**
   * Creates an instance of common service.
   * @param sanitizer 
   * @param router 
   * @param _location 
   * @param translate 
   */
  constructor(private sanitizer: DomSanitizer,
    private router: Router,
    private _location: Location,
    private serviceManager: ServiceManagerService,
    private translate: TranslateService,) { 
      this.detectDevice()
    }



  detectDevice(){
    let details = navigator.userAgent;
  
    /* Creating a regular expression 
    containing some mobile devices keywords 
    to search it in details string*/
    let regexp = /android|iphone|kindle|ipad/i;
  
    /* Using test() method to search regexp in details
    it returns boolean value*/
    let isMobileDevice = regexp.test(details);

    if (isMobileDevice) {
      this.currentDevice = "mobile"
    } else {
        this.currentDevice = "desktop"
  }
}
  /**
   * Navigates to page with state
   * @param page 
   * @param [state] 
   */
  navigateToPageWithState(page: any, state = {}) {
    this.router.navigate([page], { state: state })
  }


  /**
   * Navigates to page
   * @param page 
   * @param [queryParams] 
   */
  public navigateToPage(page: any, queryParams = {}) {
    this.router.navigate([page], { queryParams: queryParams })
  }

  /**
   * Shows toolbar
   * @returns true or false based on the url
   */
  showMenubar() {
    return this.checkRoute()
  }

  /**
   * Checks route to show menu and chat options
   * @returns  
   */
  checkRoute() {
    var excludedUrl = ['help-us', 'policy-disclaimer', 'app-disclaimer', 'landing-page']
    var url = this.router.url.split("?")
    if (url[0] == "/policy-terms" && url[1]) {
      return false
    }
    return !excludedUrl.filter((url: any) => {
      return this.router.url.includes(url)
    }).length
  }

  /**
   * Shows chat
   * @returns  
   */
  showChatOption() {
    if (!this.chatExist)
      return this.chatExist
    return this.checkRoute()
  }
  
  /**
   * Go back
   */
  goBack() {
    this._location.back()
  }

  /**
   * Translates content
   * @param key 
   * @param [param] 
   * @returns  
   */
  translateContent(key: any, param = null) {
    if (param)
      return this.translate.instant(key, param)
    else
      return this.translate.instant(key)
  }

  /**
   * Determines whether filled is
   * @param inputVar 
   * @returns  
   */
  isFilled(inputVar: any) {
    return inputVar !== undefined && inputVar !== null && inputVar.toString().trim()
  }
  
  /**
   * Determines whether valid email is
   * @param email 
   * @returns  
   */
  isValidEmail(email: any){
    var mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    return Boolean(email.match(mailFormat))
  }


  /**
   * Checks user exists
   * @returns  
   */
  checkUserExists() {
    this.userId = localStorage.getItem("userId")
    return this.isFilled(this.userId)
  }

  /**
   * Gets modal background img
   * @param color 
   * @returns  
   */
  getModalBackgroundImg(color: any) {
    var svg = `<svg width="45%" height="100%" viewBox="0 0 899 800" 
    fill="none" xmlns="http://www.w3.org/2000/svg"> 
    <path d="M-77.3678 494C-62.1879 430.797 57.3253 227.226 219.132 364C442.132 552.5 545.624 190.768 519.132 113.5C507.475 79.5 454.132 104 486.632 146C519.132 188 635.632 179.142 713.632 141C791.632 102.858 909.887 -13.8344 893.632 -73.9998" 
    stroke="${color}" stroke-width="6"/> </svg>`
    return this.sanitizer.bypassSecurityTrustHtml(svg)

  }


  /**
   * Saves language
   * @param language 
   * @param route 
   */
  saveLanguage(language: any, route: any) {
    localStorage.setItem("language", language)
    this.translate.use(language)
    this.router.navigate([route])
  }


    /**
   * Checks chat exist
   * @returns  
   */
    checkChatExist(isTransferred: any = false){
      return new Promise((resolve: any, reject: any) =>{
        var userId  = localStorage.getItem("userId")
        if(!userId){
          resolve(false)
          return
        }
        var body = {
          "user_id": userId
        }
        this.serviceManager.CallBackendServiceAPI('chat_exist', body).subscribe(
          (response: any) => {
            this.chatExist = response["response"]["is_exist"]
            if(this.chatExist){
              localStorage.removeItem("currentProgress")
            //   localStorage.removeItem("userId")
            }
            if(response["response"]["user_detail"]){
              this.peerDetails = response["response"]["user_detail"]
              this.chatTransferred = this.peerDetails.role == "Mentor"
              this.current.page = this.chatTransferred  ? 'TRANSFER-HOME' : this.current.page
            }

            if(isTransferred){
              this.setChatProcess("CHAT-BEGIN")
            }
            resolve(this.chatExist)
          },
          (error: any) => {}
        )
      })
    }

  /**
   * Sets chat process
   * @param state 
   */
  setChatProcess(state: any) {
    var message: any = {};
    var chatProcess = JSON.parse(localStorage.getItem("chatProcess") || '[]')
    var processObj: any = {
      "CHAT-BEGIN": "chat.beginMsg",
      "TRANSFER-REQUEST": "chat.transferRequest",
      "TRANSFER-INITIATED": "chat.transferInitiated",
      "TRANSFER-CANCELED": "chat.transferCanceled",
      "TRANSFER-FAILED": "chat.transferFailed",
      "TRANSFERRING": "chat.transferProgress",
      "TRANSFERRED": "chat.transferred",
      "PEER-LEFT": "chat.peerLeft"
    }
    message["process"] = processObj[state]

    if(state == "CHAT-BEGIN"){
      message["user"] = this.peerDetails.displayName
    }
    if (chatProcess[chatProcess.length - 1] && chatProcess[chatProcess.length - 1]?.process == message["process"]) {
      return
    }
    message["isNotMessage"] = true
    message["isShowed"] = false
    message["state"] = state
    var date = new Date().toLocaleString().split(',')
    // var isValid = true;
    // var socketStatus = ["OFFLINE", "ONLINE"]
    // if (socketStatus.includes(state)) {
    //   var date = new Date(this.socketCheckTime).toLocaleString().split(',')
    //   var i = chatProcess.length - 1;
    //   for (; i >= 0; i--) {
    //     if (chatProcess[i]["state"] == socketStatus[socketStatus.indexOf(state) == 0 ? 1 : 0]) {
    //       break;
    //     }
    //     else if (chatProcess[i]["state"] == state) {
    //       isValid = false
    //       break;
    //     }
    //   }
    // }
    // if (!isValid) {
    //   return
    // }
    message["date"] = date[0]
    message["time"] = date[1]
    chatProcess.push(message)
    localStorage.setItem("chatProcess", JSON.stringify(chatProcess))
    this.chatScroll.next("status")
  }

  /**
   * Clears timeout
   */
  clearTimeout(){
    var id = window.setTimeout(function() {}, 0);
    while (id--) {
        window.clearTimeout(id); // will do nothing if no timeout with id is present
    }
  }

  /**
   * Gets socket offline status
   * @returns  
   */
  getSocketOfflineStatus(){
    var chatProcess = JSON.parse(localStorage.getItem("chatProcess") || '[]')
    var isOnline = true;
    var i = chatProcess.length - 1;
    for (; i >= 0; i--) {
      if (chatProcess[i]["state"] == "OFFLINE") {
        isOnline = false
        break;
      }
      else if (chatProcess[i]["state"] == "ONLINE") {
        break;
      }
    }
    return isOnline
  }
}
